<template>
  <div class="enterpriseHighNewH5">
    <a-spin :spinning="pdfLoading" tip="正在生成报告，请稍等 ...">
      <div class="pageTop">
        <div class="title">
          <!--        <img src="@/assets/images/gx-title.png" alt="" />-->
          <span>企业政策扶持报告</span>
        </div>
        <div class="desc">3秒快速出报告，一键即可获取</div>
        <van-field
          ref="companyNameRef"
          class="input"
          v-model="companyName"
          placeholder="请输入企业名称，如“汉唐信通”"
          @click-right-icon="getCorpInfo"
          @input="getCompanyList"
        >
          <template #right-icon>
            <svg-icon icon-class="gx-search" class="gx-search"></svg-icon>
          </template>
        </van-field>
      </div>
      <dropDown
        ref="dropDownRef"
        :companyList="companyList"
        :visible.sync="visible"
        :flag="0"
        :loading="loading"
        :isEmpty="isEmpty"
        class="dropDown"
        @checkName="checkName"
      />
      <van-popup v-model="show" class="popup">
        <div class="prompt">
          <div class="promptHead">
            <div class="promptTitle">温馨提示</div>
            <svg-icon
              icon-class="gx-cancel"
              class="gx-cancel"
              @click="show = false"
            ></svg-icon>
          </div>
          <div class="promptBody">
            <svg-icon icon-class="gx-null" class="gx-null"></svg-icon>
            <div>企业成立时间不足一年，不符合认定条件</div>
          </div>
          <div class="promptFooter" @click="show = false">我知道了</div>
        </div>
      </van-popup>
      <div
        class="list"
        v-for="(item, index) in list"
        :key="index"
        :class="item.path"
      >
        <div class="listTitle">
          <div class="circleBox">
            <div class="circleThree circle"></div>
            <div class="circleTwo circle"></div>
            <div class="circleOne"></div>
          </div>
          <div class="titleText">{{ item.title }}</div>
          <div class="circleBox">
            <div class="circleOne circle"></div>
            <div class="circleTwo circle"></div>
            <div class="circleThree"></div>
          </div>
        </div>
        <div
          class="content"
          :class="index == 1 || index == 2 ? 'specialContent' : ''"
        >
          <div v-for="(item, index) in item.content" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </a-spin>
    <van-dialog
      v-model="pdfVisible"
      title=""
      :showConfirmButton="false"
      show-cancel-button
      @cancel="cancelDownload"
    >
      <div style="text-align: center; margin: 20px">报告已生成，请点击下载</div>
      <div style="text-align: center; margin: 20px">
        <!--        <a-button type="link" size="large">下载</a-button>-->
        <a :href="pdfUrl">下载</a>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import axios from "axios";
import {
  highTechBasisReportApi,
  getCorpInfoApi,
} from "@/api/enterpriseHighNewH5";
import { getCompanyInfo } from "@/api/enterpriseHighNew";
import dropDown from "../ctmRiskH5/components/dropDown.vue";
import moment from "moment";

export default {
  components: {
    dropDown,
  },
  data() {
    return {
      show: false, //控制弹窗显示
      companyName: "", //企业名称
      reportContent: {}, //报告内容
      reportId: "", //报告Id
      companyList: [], //公司列表
      visible: false, //控制下拉框显示
      loading: true, //加载
      isEmpty: false, //暂无数据
      specialContent: "",
      pdfVisible: false,
      pdfUrl: "",
      pdfLoading: false,
      list: [
        {
          title: "为什么要做企业商标风险检测",
          content: [
            "1. 税收政策 : 享受国家税收优惠",
            "2. 优先上市 : 为上市奠定了良好的基础",
            "3. 政策补贴 : 享受国家财政补贴",
            "4. 定位明确 : 利于企业宣传，树立品牌形象",
            "5. 产品竞争力 : 提升企业核心产业",
            "6. 招商引资 : 助力企业融资",
          ],
          path: "listOne",
        },
      ],
    };
  },
  created() {
    if (this.$route.query.userId) {
      let userInfo = {
        userId: this.$route.query.userId,
        username: this.$route.query.username,
        orgId: this.$route.query.orgId,
        orgName: this.$route.query.orgName,
      };
      if (this.$route.query.applets) {
        userInfo.applets = this.$route.query.applets;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  },
  mounted() {
    const trigger = (el) => {
      if (this.visible) {
        if (
          this.$refs.dropDownRef.$el &&
          !this.$refs.dropDownRef.$el.contains(el.target)
        ) {
          this.visible = false;
          this.companyName = "";
        }
      }
    };
    document.addEventListener("click", trigger);
  },
  methods: {
    // 点击补充信息跳转到测评页
    addInfo() {
      this.$router.push({
        name: "enterpriseHighNewH5Evaluation",
        params: {
          companyName: this.companyName,
        },
      });
    },
    // 接收列表点击的值
    checkName(item) {
      this.pdfLoading = true;
      this.companyName = item;

      axios({
        method: "get",
        url:
          "https://reporting.gongsibao.com/api/pdf/enterpriseTmRiskAnalysisForUrl?companyName=" +
          item,
        headers: { appKey: "ds3hja14djc134qoe" },
      })
        .then((res) => {
          this.pdfLoading = false;
          this.pdfUrl = res.data.data;
          this.pdfVisible = true;
        })
        .catch((error) => {
          this.$message.warning(error);
        });
    },
    goBack() {
      console.log(111);
      this.$router.go(-1);
    },
    getCompanyList() {
      if (this.companyName.trim()) {
        this.visible = true;
        this.loading = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.getCompanyInfo1();
        }, 800);
      } else {
        this.visible = false;
      }
    },
    // 高新测评报告-基础版
    async highTechBasisReport() {
      // if (!this.companyName) return
      const res = await highTechBasisReportApi({
        companyName: this.companyName,
      });
      if (res.code == 0) {
        this.reportId = res.data.reportId;
        this.$router.push({
          path: "/enterpriseHighNewH5/basicReport",
          query: {
            reportId: res.data.reportId,
          },
        });
      }
    },
    // 获取公司列表
    async getCompanyInfo1() {
      if (!this.companyName || !this.companyName.trim()) {
        this.visible = false;
        return;
      }
      this.loading = true;
      const res = await getCompanyInfo({
        name: this.companyName,
      });
      if (res.code == 0) {
        this.companyList = res.data;
        this.loading = false;
        if (this.companyList.length > 0) {
          this.isEmpty = false;
        } else {
          this.isEmpty = true;
        }
      }
    },
    // 获取工商信息
    async getCorpInfo() {
      if (!this.companyName || !this.companyName.trim()) {
        // this.$notify('请输入企业名称')
        this.$notify({ type: "warning", message: "请输入企业名称" });
        return;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      const res = await getCorpInfoApi({
        companyName: this.companyName,
      });
      if (res.code == 0) {
        if (res.data.name == null) {
          this.$toast("暂未查询到相关信息，建议您重新输入");
          return;
        }
        let m2 = res.data.foundedTime.replace("-", "/").replace("-", "/");
        if (moment().diff(moment(m2).format("YYYY-MM-DD"), "year") < 1) {
          this.show = true;
        } else {
          this.highTechBasisReport();
        }
      }
    },
    cancelDownload() {
      this.companyName = "";
      this.pdfUrl = "";
    },
  },
};
</script>
<style lang="less" scoped>
.enterpriseHighNewH5 {
  padding-bottom: 0.34rem;
  position: relative;

  .dropDown {
    width: 6.7rem;
    height: 4.48rem;
    position: absolute;
    top: 3.74rem;
    left: 0.4rem;
    z-index: 999;
  }

  .pageTop {
    width: 100%;
    height: 4.17rem;
    background-image: url("~@/assets/images/gxbg.png");
    background-size: 100% 100%;
    padding-top: 0.3rem;

    .lineIcon {
      display: flex;
      justify-content: space-between;
      margin: 0 0.3rem;

      .back {
        width: 0.2rem;
        height: 0.36rem;
      }

      .changeAccount {
        cursor: pointer;

        .change {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.1rem;
        }

        span {
          font-size: 0.24rem;
          color: #ffffff;
        }
      }
    }

    .title {
      text-align: center;
      margin-top: 0.51rem;

      img {
        width: 6.84rem;
        height: 0.84rem;
      }

      font-size: 30px;
      color: #ffffff;
    }

    .desc {
      text-align: center;
      color: #b7d4fc;
      font-size: 0.22rem;
      margin-top: 0.11rem;
    }

    .van-cell {
      padding: 0.21rem 0.16rem 0.1rem;
    }

    .input {
      width: 6.7rem;
      height: 0.84rem;
      border-radius: 0.07rem;
      margin: 0.45rem auto 0px auto;

      .gx-search {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }

  .popup {
    border-radius: 0.3rem;

    .prompt {
      width: 5.4rem;
      height: 5.7rem;
      margin-top: 0.22rem;

      .promptHead {
        height: 1.5rem;
        position: relative;

        .promptTitle {
          font-size: 0.36rem;
          font-weight: 500;
          position: absolute;
          top: 0.5rem;
          left: 1.98rem;
        }

        .gx-cancel {
          width: 0.36rem;
          height: 0.36rem;
          position: absolute;
          top: 0.3rem;
          right: 0.3rem;
          cursor: pointer;
        }
      }

      .promptBody {
        height: 3rem;
        display: flex;
        justify-content: center;
        font-size: 0.26rem;
        position: relative;

        .gx-null {
          width: 2.27rem;
          height: 2.4rem;
          position: absolute;
          top: 0;
          left: 1.57rem;
        }

        div {
          position: absolute;
          top: 2.06rem;
        }
      }

      .promptFooter {
        height: 1.2rem;
        background: #f7f7f7;
        border-radius: 0px 0px 0.3rem 0.3rem;
        font-size: 0.3rem;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }

  .listOne {
    background-image: url("~@/assets/images/gxbg1.png");
  }

  .listTwo {
    background-image: url("~@/assets/images/gxbg2.png");
  }

  .listThree {
    background-image: url("~@/assets/images/gxbg3.png");
  }

  .listFour {
    background-image: url("~@/assets/images/gxbg4.png");
  }

  .list {
    width: 7.1rem;
    min-height: 4.41rem;
    box-shadow: 0rem 0.04rem 0.14rem 0rem rgba(237, 243, 253, 0.47);
    border-radius: 0.09rem;
    border: 0.01rem solid rgba(0, 114, 247, 0.07);
    margin: 0.2rem auto 0 auto;
    position: relative;
    background-size: 2.05rem 1.32rem;
    background-repeat: no-repeat;
    background-position: right bottom;

    .listTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.51rem;

      .titleText {
        font-size: 0.3rem;
        margin: 0 0.16rem;
      }

      .circleBox {
        height: 0.1rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .circle {
          margin-right: 0.12rem;
        }

        .circleOne {
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background: rgba(51, 113, 255, 0.7);
        }

        .circleTwo {
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 50%;
          background: rgba(51, 113, 255, 0.5);
        }

        .circleThree {
          width: 0.04rem;
          height: 0.04rem;
          background: rgba(51, 113, 255, 0.3);
        }
      }
    }

    .content {
      width: 6.5rem;
      // height: 2.73rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #777777;
      margin: 0.37rem auto 0 auto;
    }

    .specialContent {
      padding-bottom: 0.5rem;
    }
  }
}
</style>
